<div class="m-20">
  <h3>Deze link is niet meer geldig</h3>
  <p>
    De tijd om de vragenlijst in te vullen voor deze uitvraag is voorbij (of het invullen is niet meer nodig) en daarmee
    is de link verlopen. Bij vragen kan contact opgenomen worden met het klant team via
    <a href="mailto:{{ clientTeamEmailAddress() }}">{{ clientTeamEmailAddress() }}</a
    >.
  </p>
</div>
<div class="mx-48"><hr class="border-2 border-gray-300" /></div>
<div class="m-20">
  <h3>This link is no longer available or not valid</h3>
  <p>
    The time to complete the questionnaire for this survey has passed, and the link has expired. If you have any
    questions, please contact the customer service team at
    <a href="mailto:{{ clientTeamEmailAddress() }}">{{ clientTeamEmailAddress() }}</a
    >.
  </p>
</div>
